export class Configuration {
	public API_PROCEDURE_URL: string =
		document.getElementsByTagName("base")[0].href + "backend";
	public API_AUTH_URL: string =
		document.getElementsByTagName("base")[0].href + "authentication";
	public TOKEN: string;

	constructor() {
		this.TOKEN =
			JSON.parse(<string>localStorage.getItem("userMESData"))?.token || "";
	}
}
